import * as turf from '@turf/turf';

(function commonUtil(window) {
    /**
     * @description 将20200122120506 格式时间时区时间转换为标准格式时间
     * @date 2021.01.22
     * @param window
     * @return Obj
     */

    function airTimeFormat(timeStr, formate, timeZone) {
        timeStr = timeStr + "";
        //不满14位补齐14位,否则只保留14位
        let timeStr14 = "";
        for (let i = 0; i < 14; i++) {
            if (timeStr.length >= i + 1) {
                timeStr14 += timeStr.charAt(i);
            } else {
                timeStr14 += "0";
            }
        }

        let date = new Date();
        let year = timeStr14.substring(0, 4);
        let month = timeStr14.substring(4, 6);
        let day = timeStr14.substring(6, 8);
        let hour = timeStr14.substring(8, 10);
        let min = timeStr14.substring(10, 12);
        let sec = timeStr14.substring(12, 14);

        if (timeZone == "ED8") {
            date.setFullYear(year, parseInt(month) - 1, day);
            date.setHours(hour, min, sec)
        } else { //默认按照世界时间处理
            date.setUTCFullYear(year, parseInt(month) - 1, day);
            date.setUTCHours(hour, min, sec)
        }

        if (formate) {
            return dateFormat(formate, date);
        }

        return date;
    }

    /**
     * @describe 通过经纬度计算两点间的直线距离
     * @date 2021.01.22
     * @param lat1
     * @param lng1
     * @param lat2
     * @param lng2
     * @returns {number}
     */
    function getDistance(lat1, lng1, lat2, lng2) {
        var radLat1 = lat1 * Math.PI / 180.0;
        var radLat2 = lat2 * Math.PI / 180.0;
        var a = radLat1 - radLat2;
        var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
        var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
        s = s * 6378.137;
        s = Math.round(s * 10000) / 10000;
        return s // 单位千米
    }

    /**
     * @description 时间格式化
     * @date 2021.01.22
     */
    function dateFormat(fmt, date) {
        let ret;
        const opt = {
            "Y+": date.getFullYear().toString(), // 年
            "m+": (date.getMonth() + 1).toString(), // 月
            "d+": date.getDate().toString(), // 日
            "H+": date.getHours().toString(), // 时
            "M+": date.getMinutes().toString(), // 分
            "S+": date.getSeconds().toString() // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            };
        };
        return fmt;
    }

    function vectorToDegrees(uMs, vMs) {
        var windAbs = Math.sqrt(Math.pow(uMs, 2) + Math.pow(vMs, 2));
        var windDirTrigTo = Math.atan2(uMs / windAbs, vMs / windAbs);
        var windDirTrigToDegrees = windDirTrigTo * 180 / Math.PI;
        var windDirTrigFromDegrees = windDirTrigToDegrees + 180;
        if (windDirTrigFromDegrees >= 0 && windDirTrigFromDegrees <= 180) {
            windDirTrigFromDegrees = 180 - windDirTrigFromDegrees;
        } else if (windDirTrigFromDegrees >= 270 && windDirTrigFromDegrees <= 360) {
            windDirTrigFromDegrees = 180 + (360 - windDirTrigFromDegrees);
        } else if (windDirTrigFromDegrees < 270 && windDirTrigFromDegrees > 180) {
            windDirTrigFromDegrees = 360 - (windDirTrigFromDegrees - 180)
        }

        return windDirTrigFromDegrees.toFixed(3);
    }

    /**
     *海拔高度转hpa
     */
    function altitude2Hpa(altitude) {
        if (0 <= altitude && altitude < 100) {
            return 'SFC'
        } else if (100 <= altitude && altitude < 300) {
            return (altitude - 100) >= (300 - altitude) ? 975 : 1000;
        } else if (300 <= altitude && altitude < 600) {
            return (altitude - 300) >= (600 - altitude) ? 950 : 975;
        } else if (600 <= altitude && altitude < 750) {
            return (altitude - 600) >= (750 - altitude) ? 925 : 950;
        } else if (750 <= altitude && altitude < 900) {
            return (altitude - 750) >= (900 - altitude) ? 900 : 925;
        } else if (900 <= altitude && altitude < 1500) {
            return (altitude - 900) >= (1500 - altitude) ? 850 : 900;
        } else if (1500 <= altitude && altitude < 2000) {
            return (altitude - 1500) >= (2000 - altitude) ? 800 : 850;
        } else if (2000 <= altitude && altitude < 2400) {
            return (altitude - 2000) >= (2400 - altitude) ? 750 : 800;
        } else if (2400 <= altitude && altitude < 3000) {
            return (altitude - 2400) >= (3000 - altitude) ? 700 : 750;
        } else if (3000 <= altitude && altitude < 3600) {
            return (altitude - 3000) >= (3600 - altitude) ? 650 : 700;
        } else if (3600 <= altitude && altitude < 4200) {
            return (altitude - 3600) >= (4200 - altitude) ? 600 : 650;
        } else if (4200 <= altitude && altitude < 4800) {
            return (altitude - 4200) >= (4800 - altitude) ? 550 : 600;
        } else if (4200 <= altitude && altitude < 5500) {
            return (altitude - 4200) >= (5500 - altitude) ? 500 : 550;
        } else if (5500 <= altitude && altitude < 6200) {
            return (altitude - 5500) >= (6200 - altitude) ? 450 : 500;
        } else if (6200 <= altitude && altitude < 7000) {
            return (altitude - 6200) >= (7000 - altitude) ? 400 : 450;
        } else if (7000 <= altitude && altitude < 7900) {
            return (altitude - 7000) >= (7900 - altitude) ? 350 : 400;
        } else if (7900 <= altitude && altitude < 9000) {
            return (altitude - 7900) >= (9000 - altitude) ? 300 : 350;
        } else if (9000 <= altitude && altitude < 10000) {
            return (altitude - 9000) >= (10000 - altitude) ? 250 : 300;
        } else if (10000 <= altitude && altitude < 11700) {
            return (altitude - 10000) >= (11700 - altitude) ? 200 : 250;
        } else if (11700 <= altitude && altitude < 13500) {
            return (altitude - 11700) >= (13500 - altitude) ? 150 : 200;
        } else if (13500 <= altitude && altitude < 15900) {
            return (altitude - 13500) >= (15900 - altitude) ? 100 : 150;
        } else if (15900 <= altitude && altitude < 17600) {
            return (altitude - 15900) >= (17600 - altitude) ? 70 : 100;
        } else if (17600 <= altitude && altitude < 19300) {
            return (altitude - 17600) >= (19300 - altitude) ? 50 : 70;
        } else if (19300 <= altitude && altitude < 23300) {
            return (altitude - 19300) >= (23300 - altitude) ? 20 : 50;
        } else if (23300 <= altitude && altitude <= 25900) {
            return (altitude - 23300) >= (25900 - altitude) ? 10 : 20;
        }

        return NaN;
    }

    /**
     * 常见hpa转海拔高度
     */
    function hpa2Altitude(hpa) {
        var altitude = 0;

        switch (hpa) {
            case 1000:
                altitude = 100;
                break;
            case 975:
                altitude = 300;
                break;
                break;
            case 950:
                altitude = 600;
                break;
            case 925:
                altitude = 750;
                break;
            case 900:
                altitude = 900;
                break;
            case 850:
                altitude = 1500;
                break;
            case 800:
                altitude = 2000;
                break;
            case 750:
                altitude = 2400;
                break;
            case 700:
                altitude = 3000;
                break;
            case 650:
                altitude = 3600;
                break;
            case 600:
                altitude = 4200;
                break;
            case 550:
                altitude = 4800;
                break;
            case 500:
                altitude = 5500;
                break;
            case 450:
                altitude = 6200;
                break;
            case 400:
                altitude = 7000;
                break;
            case 350:
                altitude = 7900;
                break;
            case 300:
                altitude = 9000;
                break;
            case 250:
                altitude = 10000;
                break;
            case 200:
                altitude = 11700;
                break;
            case 150:
                altitude = 13500;
                break;
            case 100:
                altitude = 15900;
                break;
            case 70:
                altitude = 17600;
                break;
            case 50:
                altitude = 19300;
                break;
            case 20:
                altitude = 23300;
                break;
            case 10:
                altitude = 25900;
                break;
            default:
                altitude = 0;
        }

        return altitude;
    }

    /**
     * 根据日期字符串获取星期几
     * @param dateString 日期字符串（如：2020-05-02）
     * @returns {String}
     */
    function getWeek(dateString) {
        var dateArray = dateString.split("-");
        date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
        return "周" + "日一二三四五六".charAt(date.getDay());
    };


    /**
     * @describe 度分秒换算经纬度
     * @author ZhaoWei
     * @date 2021.01.22
     * @param type lat/lon 类型，经度或纬度
     * @param value 经度或纬度值
     */
    function dms2ddd(type, value) {
        let result = "";
        let a, b;
        let min = 0; //分
        let sec = 0; //秒

        let sign = ""; //符号
        if (type == "lat") {
            if (value.charAt(0) == "-") {
                sign = value.charAt(0);
                a = value.substring(1, 3);
                b = value.substring(3);
            } else {
                a = value.substring(0, 2);
                b = value.substring(2);
            }


        } else if (type == "lon") {

            if (value.charAt(0) == "-") {

                a = value.substring(1, 4);
                b = value.substring(4);
            } else {
                sign = "-";
                a = value.substring(0, 3);
                b = value.substring(3);
            }
        }

        let minSec = b.split(".");

        if (minSec.length == 1) {
            min = minSec[0];
        } else if (minSec.length == 2) {
            min = minSec[0];
            sec = minSec[1];
        }

        result = parseFloat(a) + parseFloat(min) / 60 + parseFloat(sec) / 600;

        return parseFloat(sign + result);
    }

    //度转度°分′秒″
    function ToDegrees(val) {
        if (typeof(val) == "undefined" || val == "") {
            return [0, 0, 0];
        }
        val = Math.abs(val); //返回数的绝对值
        var v1 = Math.floor(val); //度   //对数进行下舍入
        var v2 = Math.floor((val - v1) * 60); //分  
        var v3 = Math.round((val - v1) * 3600 % 60); //秒  //把数四舍五入为最接近的整数

        return [v1, v2, v3];
    };

    //度°分′秒″转度
    function ToDigital(strDu, strFen, strMiao, len) {
        len = (len > 6 || typeof(len) == "undefined") ? 6 : len; //精确到小数点后最多六位   
        strDu = (typeof(strDu) == "undefined" || strDu == "") ? 0 : parseFloat(strDu);
        strFen = (typeof(strFen) == "undefined" || strFen == "") ? 0 : parseFloat(strFen) / 60;
        strMiao = (typeof(strMiao) == "undefined" || strMiao == "") ? 0 : parseFloat(strMiao) / 3600;
        var digital = strDu + strFen + strMiao;
        if (digital == 0) {
            return 0;
        } else {
            return digital.toFixed(len);
        }
    }

    function Dms2D(dms_data) {

        let du = dms_data.substring(0, dms_data.indexOf("°"));
        let fen = dms_data.substring(dms_data.indexOf("°") + 1, dms_data.indexOf("′"));
        let miao = dms_data.substring(dms_data.indexOf("′") + 1, dms_data.indexOf("″"));
        return ToDigital(du, fen, miao);
    }


    function urlToBlob(file_url) {
        return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open("get", file_url, true);
            xhr.responseType = "blob";
            xhr.onload = function() {
                if (this.status == 200) {
                    resolve(this.response);
                }
            };
            xhr.send();
        })
    }

    //转base64
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            let fileResult = "";

            console.log(file);
            reader.readAsDataURL(file); //开始转
            reader.onload = function() {
                fileResult = reader.result;
            }; //转失败
            reader.onerror = function(error) {
                reject(error);
            }; //转结束
            reader.onloadend = function() {
                fileResult = fileResult.split(',')[1];
                resolve(fileResult);
            }
        })

    }

    function getDate(str) {
        return str.split('/').join('-');
    }

    /**
     * 获取指定分钟之后的时间
     */
    function getAfterMinTime(date, afterMin) {
        if (!date) {
            date = new Date();
        }
        var min = date.getMinutes(); //2. 获取当前分钟
        date.setMinutes(min + afterMin); //3. 设置当前时间+10分钟：把当前分钟数+10后的值重新设置为date对象的分钟数
        var y = date.getFullYear();
        var m = (date.getMonth()) < 10 ? ("0" + (date.getMonth())) : (date.getMonth());
        var d = date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate();
        var h = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
        var f = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
        var s = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()

        date.setFullYear(y, m, d);
        date.setHours(h, f, s);

        return date;
    }

    /**
     * 获取时间
     */
    function timeZoneFormat(t, timeOffset) {

        let timestamp = airTimeFormat(t, null, "ED8").getTime();
        timestamp = timestamp + timeOffset * 1000 * 60 * 60

        return new Date(timestamp);

    }

    /**
     * 二维数组的indexOf
     * @param array
     * @param item
     * @returns {boolean}
     */
    function isItemInArray(array, item) {
        for (var i = 0; i < array.length; i++) {
            // This if statement depends on the format of your array
            if (array[i][0] == item[0] && array[i][1] == item[1]) {
                return true; // Found it
            }
        }
        return false; // Not found
    }

    /**
     * 将毫秒转化为时分秒的描述文字
     * @param mss
     * @returns {string}
     */
    function formatDuring(mss) {
        var days = parseInt(mss / (1000 * 60 * 60 * 24));
        var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = (mss % (1000 * 60)) / 1000;

        var returnTxt = "";
        if (days != 0) {
            returnTxt += days + "天";
        }

        if (hours != 0) {
            returnTxt += hours + "小时";
        }

        if (minutes != 0) {
            returnTxt += minutes + "分钟";
        }

        if (seconds != 0) {
            returnTxt += seconds + "秒";
        }

        return returnTxt;
    }

    /**
     * 数组分组
     */
    function  groupBy(array,  f) {
        let  groups  =   {};
        array.forEach(function (o)  {
            var  group  =  JSON.stringify(f(o));
            groups[group]  =  groups[group]  ||  [];
            groups[group].push(o);
        });
        return  Object.keys(groups).map(function (group)  {
            return  groups[group];
        });
    };

    function  arrayGroupBy(list,  groupId) {
        let  sorted  =  groupBy(list,  function (item)  {
            return  [item[groupId]];
        });
        return  sorted;
    };

    /**
     * 随机生成颜色
     * @returns {string}
     */
    function rgbRandom() { //rgb颜色随机
        var r = Math.floor(Math.random() * 256);
        var g = Math.floor(Math.random() * 256);
        var b = Math.floor(Math.random() * 256);
        var rgb = 'rgb(' + r + ',' + g + ',' + b + ')';
        return rgb;
    }

    /**
     * 获取地址栏参数
     */
    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    }

    /**
     * 获取渐变颜色
     */
    function getColorRamp(colors) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = 256 * 2;
        canvas.height = 1;

        const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        for (const stop in colors) {
            gradient.addColorStop(+stop, colors[stop]);
        }

        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, 1);

        return new Uint8Array(ctx.getImageData(0, 0, canvas.width, 1).data);
    }

    function getAngle(start, finish) {
        var point1 = turf.point(start);
        var point2 = turf.point(finish);
        var bearing = turf.bearing(point1, point2);
        return bearing;
    }

    function vectorToSpeed(uMs, vMs) {
        var windAbs = Math.sqrt(Math.pow(uMs, 2) + Math.pow(vMs, 2));
        return windAbs;
    }

    var mask_top = {
        mcappi: {
            "type": "FeatureCollection",
            "name": "qz_mask",
            "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
            "features": [{
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [118.896110534667969, 28.073507308959961],
                            [118.878372192382813, 28.073640823364258],
                            [118.860641479492188, 28.074047088623047],
                            [118.842918395996094, 28.074724197387695],
                            [118.825218200683594, 28.07567024230957],
                            [118.807533264160156, 28.076887130737305],
                            [118.789871215820313, 28.078376770019531],
                            [118.772247314453125, 28.080131530761719],
                            [118.754653930664063, 28.082157135009766],
                            [118.737106323242188, 28.084451675415039],
                            [118.7196044921875, 28.087015151977539],
                            [118.702163696289063, 28.089841842651367],
                            [118.684768676757813, 28.092937469482422],
                            [118.667442321777344, 28.096296310424805],
                            [118.650184631347656, 28.099920272827148],
                            [118.63299560546875, 28.103805541992188],
                            [118.615890502929688, 28.107955932617188],
                            [118.598861694335938, 28.112363815307617],
                            [118.581924438476563, 28.117031097412109],
                            [118.565078735351563, 28.121957778930664],
                            [118.54833984375, 28.127140045166016],
                            [118.531692504882813, 28.132577896118164],
                            [118.515159606933594, 28.138271331787109],
                            [118.498741149902344, 28.144210815429688],
                            [118.482437133789063, 28.15040397644043],
                            [118.466262817382813, 28.156843185424805],
                            [118.450210571289063, 28.163530349731445],
                            [118.434295654296875, 28.17045783996582],
                            [118.418510437011719, 28.177631378173828],
                            [118.402877807617188, 28.185043334960938],
                            [118.387382507324219, 28.192693710327148],
                            [118.372047424316406, 28.200578689575195],
                            [118.356864929199219, 28.208694458007813],
                            [118.341835021972656, 28.217046737670898],
                            [118.326980590820313, 28.225622177124023],
                            [118.312294006347656, 28.234424591064453],
                            [118.297782897949219, 28.243450164794922],
                            [118.283447265625, 28.252695083618164],
                            [118.269294738769531, 28.26215934753418],
                            [118.255325317382813, 28.27183723449707],
                            [118.241554260253906, 28.281726837158203],
                            [118.227973937988281, 28.291826248168945],
                            [118.214599609375, 28.302129745483398],
                            [118.201423645019531, 28.31263542175293],
                            [118.188453674316406, 28.323343276977539],
                            [118.175697326660156, 28.334243774414063],
                            [118.163154602050781, 28.345342636108398],
                            [118.150833129882813, 28.356624603271484],
                            [118.138740539550781, 28.368097305297852],
                            [118.126869201660156, 28.379755020141602],
                            [118.115226745605469, 28.39158821105957],
                            [118.10382080078125, 28.403600692749023],
                            [118.0926513671875, 28.41578483581543],
                            [118.081718444824219, 28.428134918212891],
                            [118.071037292480469, 28.440652847290039],
                            [118.060600280761719, 28.453329086303711],
                            [118.0504150390625, 28.466165542602539],
                            [118.040481567382813, 28.479152679443359],
                            [118.030799865722656, 28.492294311523438],
                            [118.021385192871094, 28.505575180053711],
                            [118.012237548828125, 28.519002914428711],
                            [118.003349304199219, 28.532566070556641],
                            [117.994728088378906, 28.5462646484375],
                            [117.986381530761719, 28.560091018676758],
                            [117.978309631347656, 28.574045181274414],
                            [117.970512390136719, 28.588117599487305],
                            [117.962989807128906, 28.60230827331543],
                            [117.955757141113281, 28.616609573364258],
                            [117.948799133300781, 28.631023406982422],
                            [117.942131042480469, 28.645538330078125],
                            [117.935752868652344, 28.660152435302734],
                            [117.929664611816406, 28.674861907958984],
                            [117.923866271972656, 28.689661026000977],
                            [117.918357849121094, 28.704551696777344],
                            [117.913154602050781, 28.719520568847656],
                            [117.908241271972656, 28.734567642211914],
                            [117.90362548828125, 28.749687194824219],
                            [117.899314880371094, 28.764873504638672],
                            [117.895301818847656, 28.780124664306641],
                            [117.891593933105469, 28.795434951782227],
                            [117.888191223144531, 28.810796737670898],
                            [117.885093688964844, 28.826211929321289],
                            [117.882301330566406, 28.841667175292969],
                            [117.879814147949219, 28.857168197631836],
                            [117.877639770507813, 28.872701644897461],
                            [117.875778198242188, 28.888267517089844],
                            [117.874221801757813, 28.903861999511719],
                            [117.872970581054688, 28.919471740722656],
                            [117.872039794921875, 28.935102462768555],
                            [117.871414184570313, 28.95074462890625],
                            [117.871101379394531, 28.966390609741211],
                            [117.871109008789063, 28.98204231262207],
                            [117.871421813964844, 28.997690200805664],
                            [117.872047424316406, 29.013330459594727],
                            [117.87298583984375, 29.028959274291992],
                            [117.874229431152344, 29.044570922851563],
                            [117.87579345703125, 29.060163497924805],
                            [117.877670288085938, 29.075729370117188],
                            [117.879852294921875, 29.091264724731445],
                            [117.882347106933594, 29.106761932373047],
                            [117.885154724121094, 29.122219085693359],
                            [117.888267517089844, 29.137630462646484],
                            [117.891693115234375, 29.152992248535156],
                            [117.895416259765625, 29.168302536010742],
                            [117.899459838867188, 29.183549880981445],
                            [117.903800964355469, 29.198736190795898],
                            [117.908447265625, 29.213851928710938],
                            [117.91339111328125, 29.228891372680664],
                            [117.918647766113281, 29.243860244750977],
                            [117.9241943359375, 29.258739471435547],
                            [117.930046081542969, 29.273536682128906],
                            [117.936195373535156, 29.288244247436523],
                            [117.942634582519531, 29.302848815917969],
                            [117.949363708496094, 29.317356109619141],
                            [117.956390380859375, 29.331758499145508],
                            [117.963706970214844, 29.346050262451172],
                            [117.9713134765625, 29.3602294921875],
                            [117.979194641113281, 29.374290466308594],
                            [117.98736572265625, 29.38823127746582],
                            [117.995819091796875, 29.402040481567383],
                            [118.004547119140625, 29.415718078613281],
                            [118.013542175292969, 29.429264068603516],
                            [118.022819519042969, 29.442670822143555],
                            [118.032363891601563, 29.455930709838867],
                            [118.04217529296875, 29.469043731689453],
                            [118.052253723144531, 29.482009887695313],
                            [118.062591552734375, 29.494815826416016],
                            [118.07318115234375, 29.507461547851563],
                            [118.084030151367188, 29.519943237304688],
                            [118.095130920410156, 29.532258987426758],
                            [118.106475830078125, 29.544403076171875],
                            [118.118072509765625, 29.556367874145508],
                            [118.129905700683594, 29.568161010742188],
                            [118.141975402832031, 29.579769134521484],
                            [118.154281616210938, 29.591188430786133],
                            [118.166816711425781, 29.602420806884766],
                            [118.179573059082031, 29.613460540771484],
                            [118.192558288574219, 29.624301910400391],
                            [118.205764770507813, 29.634943008422852],
                            [118.21917724609375, 29.645383834838867],
                            [118.232803344726563, 29.655612945556641],
                            [118.246635437011719, 29.665634155273438],
                            [118.260673522949219, 29.675445556640625],
                            [118.27490234375, 29.685037612915039],
                            [118.289329528808594, 29.694417953491211],
                            [118.303947448730469, 29.703569412231445],
                            [118.318740844726563, 29.712497711181641],
                            [118.333724975585938, 29.721199035644531],
                            [118.348876953125, 29.729671478271484],
                            [118.364204406738281, 29.737911224365234],
                            [118.379692077636719, 29.745914459228516],
                            [118.395339965820313, 29.753683090209961],
                            [118.411148071289063, 29.761205673217773],
                            [118.427108764648438, 29.768491744995117],
                            [118.443214416503906, 29.775529861450195],
                            [118.459457397460938, 29.782321929931641],
                            [118.475837707519531, 29.788862228393555],
                            [118.492355346679688, 29.795156478881836],
                            [118.508995056152344, 29.801189422607422],
                            [118.525749206542969, 29.806976318359375],
                            [118.542625427246094, 29.812501907348633],
                            [118.559616088867188, 29.817771911621094],
                            [118.576705932617188, 29.822776794433594],
                            [118.593894958496094, 29.827524185180664],
                            [118.611175537109375, 29.832004547119141],
                            [118.628555297851563, 29.836225509643555],
                            [118.646011352539063, 29.840175628662109],
                            [118.663543701171875, 29.843862533569336],
                            [118.681159973144531, 29.84727668762207],
                            [118.698829650878906, 29.850425720214844],
                            [118.716567993164063, 29.853300094604492],
                            [118.734367370605469, 29.855911254882813],
                            [118.752204895019531, 29.858242034912109],
                            [118.770095825195313, 29.860301971435547],
                            [118.78802490234375, 29.862089157104492],
                            [118.805984497070313, 29.863603591918945],
                            [118.823982238769531, 29.864839553833008],
                            [118.841995239257813, 29.865806579589844],
                            [118.860023498535156, 29.866497039794922],
                            [118.878067016601563, 29.866907119750977],
                            [118.896110534667969, 29.867042541503906],
                            [118.914154052734375, 29.866907119750977],
                            [118.932197570800781, 29.866497039794922],
                            [118.950225830078125, 29.865806579589844],
                            [118.968238830566406, 29.864839553833008],
                            [118.986236572265625, 29.863603591918945],
                            [119.004196166992188, 29.862091064453125],
                            [119.022125244140625, 29.860301971435547],
                            [119.040016174316406, 29.858242034912109],
                            [119.057861328125, 29.855911254882813],
                            [119.075653076171875, 29.853300094604492],
                            [119.093391418457031, 29.850425720214844],
                            [119.111068725585938, 29.84727668762207],
                            [119.128677368164063, 29.843862533569336],
                            [119.146209716796875, 29.840175628662109],
                            [119.163665771484375, 29.836225509643555],
                            [119.181045532226563, 29.832004547119141],
                            [119.198326110839844, 29.827524185180664],
                            [119.21551513671875, 29.822776794433594],
                            [119.23260498046875, 29.817771911621094],
                            [119.249595642089844, 29.812501907348633],
                            [119.266471862792969, 29.806976318359375],
                            [119.283233642578125, 29.801189422607422],
                            [119.29986572265625, 29.795156478881836],
                            [119.316383361816406, 29.788862228393555],
                            [119.332763671875, 29.782321929931641],
                            [119.349006652832031, 29.775529861450195],
                            [119.3651123046875, 29.768491744995117],
                            [119.381072998046875, 29.761205673217773],
                            [119.396881103515625, 29.753683090209961],
                            [119.412528991699219, 29.745914459228516],
                            [119.428016662597656, 29.737911224365234],
                            [119.443344116210938, 29.729671478271484],
                            [119.45849609375, 29.721199035644531],
                            [119.473472595214844, 29.712497711181641],
                            [119.488273620605469, 29.703569412231445],
                            [119.502891540527344, 29.694417953491211],
                            [119.517318725585938, 29.685037612915039],
                            [119.531547546386719, 29.675445556640625],
                            [119.545585632324219, 29.665634155273438],
                            [119.559417724609375, 29.655612945556641],
                            [119.573043823242188, 29.645383834838867],
                            [119.586456298828125, 29.634943008422852],
                            [119.599662780761719, 29.624301910400391],
                            [119.612648010253906, 29.613460540771484],
                            [119.625404357910156, 29.602420806884766],
                            [119.637939453125, 29.591188430786133],
                            [119.650245666503906, 29.579769134521484],
                            [119.662315368652344, 29.568161010742188],
                            [119.674148559570313, 29.556367874145508],
                            [119.685745239257813, 29.544403076171875],
                            [119.697090148925781, 29.532258987426758],
                            [119.70819091796875, 29.519943237304688],
                            [119.719039916992188, 29.507461547851563],
                            [119.729629516601563, 29.494815826416016],
                            [119.739967346191406, 29.482009887695313],
                            [119.750045776367188, 29.469043731689453],
                            [119.759857177734375, 29.455930709838867],
                            [119.769401550292969, 29.442670822143555],
                            [119.778678894042969, 29.429264068603516],
                            [119.787681579589844, 29.415718078613281],
                            [119.796401977539063, 29.402040481567383],
                            [119.804855346679688, 29.38823127746582],
                            [119.813026428222656, 29.374290466308594],
                            [119.820907592773438, 29.3602294921875],
                            [119.828514099121094, 29.346050262451172],
                            [119.835830688476563, 29.331758499145508],
                            [119.842857360839844, 29.317356109619141],
                            [119.849586486816406, 29.302848815917969],
                            [119.856033325195313, 29.288244247436523],
                            [119.862174987792969, 29.273536682128906],
                            [119.868026733398438, 29.258739471435547],
                            [119.873573303222656, 29.243860244750977],
                            [119.878829956054688, 29.228891372680664],
                            [119.883773803710938, 29.213851928710938],
                            [119.888420104980469, 29.198734283447266],
                            [119.89276123046875, 29.183549880981445],
                            [119.896804809570313, 29.168302536010742],
                            [119.900527954101563, 29.152992248535156],
                            [119.903953552246094, 29.137630462646484],
                            [119.907066345214844, 29.122219085693359],
                            [119.909873962402344, 29.106761932373047],
                            [119.912368774414063, 29.091264724731445],
                            [119.91455078125, 29.075729370117188],
                            [119.916427612304688, 29.060163497924805],
                            [119.917991638183594, 29.044570922851563],
                            [119.919235229492188, 29.028959274291992],
                            [119.920173645019531, 29.013330459594727],
                            [119.920799255371094, 28.997690200805664],
                            [119.921112060546875, 28.982040405273438],
                            [119.921119689941406, 28.966390609741211],
                            [119.920806884765625, 28.95074462890625],
                            [119.920181274414063, 28.935102462768555],
                            [119.91925048828125, 28.919471740722656],
                            [119.917999267578125, 28.903861999511719],
                            [119.91644287109375, 28.888267517089844],
                            [119.914581298828125, 28.872701644897461],
                            [119.912406921386719, 28.857168197631836],
                            [119.909919738769531, 28.841667175292969],
                            [119.907127380371094, 28.826211929321289],
                            [119.904029846191406, 28.810796737670898],
                            [119.900627136230469, 28.795431137084961],
                            [119.896919250488281, 28.780124664306641],
                            [119.892906188964844, 28.764873504638672],
                            [119.888595581054688, 28.749687194824219],
                            [119.883979797363281, 28.734565734863281],
                            [119.879066467285156, 28.719520568847656],
                            [119.873863220214844, 28.704551696777344],
                            [119.868354797363281, 28.689661026000977],
                            [119.862556457519531, 28.674861907958984],
                            [119.856468200683594, 28.660152435302734],
                            [119.850090026855469, 28.645538330078125],
                            [119.843421936035156, 28.631023406982422],
                            [119.836463928222656, 28.616609573364258],
                            [119.829231262207031, 28.60230827331543],
                            [119.821708679199219, 28.588117599487305],
                            [119.813911437988281, 28.574045181274414],
                            [119.805839538574219, 28.560091018676758],
                            [119.797492980957031, 28.5462646484375],
                            [119.788871765136719, 28.532566070556641],
                            [119.779983520507813, 28.519002914428711],
                            [119.770835876464844, 28.505575180053711],
                            [119.761421203613281, 28.492288589477539],
                            [119.751739501953125, 28.479152679443359],
                            [119.741806030273438, 28.466165542602539],
                            [119.731620788574219, 28.453329086303711],
                            [119.721183776855469, 28.440652847290039],
                            [119.710502624511719, 28.428134918212891],
                            [119.699569702148438, 28.41578483581543],
                            [119.688400268554688, 28.403600692749023],
                            [119.676994323730469, 28.39158821105957],
                            [119.665351867675781, 28.379755020141602],
                            [119.653480529785156, 28.368097305297852],
                            [119.641387939453125, 28.356624603271484],
                            [119.629066467285156, 28.345342636108398],
                            [119.616523742675781, 28.334243774414063],
                            [119.603767395019531, 28.323343276977539],
                            [119.590797424316406, 28.31263542175293],
                            [119.577621459960938, 28.302129745483398],
                            [119.564247131347656, 28.291826248168945],
                            [119.550666809082031, 28.281726837158203],
                            [119.536895751953125, 28.27183723449707],
                            [119.522926330566406, 28.26215934753418],
                            [119.508773803710938, 28.252695083618164],
                            [119.494438171386719, 28.243450164794922],
                            [119.479927062988281, 28.234424591064453],
                            [119.465240478515625, 28.225622177124023],
                            [119.45037841796875, 28.217046737670898],
                            [119.435356140136719, 28.208694458007813],
                            [119.420173645019531, 28.200578689575195],
                            [119.404838562011719, 28.192693710327148],
                            [119.38934326171875, 28.185043334960938],
                            [119.373710632324219, 28.177631378173828],
                            [119.357925415039063, 28.17045783996582],
                            [119.342010498046875, 28.163530349731445],
                            [119.325958251953125, 28.156843185424805],
                            [119.309783935546875, 28.15040397644043],
                            [119.293479919433594, 28.144210815429688],
                            [119.277061462402344, 28.138271331787109],
                            [119.260528564453125, 28.132577896118164],
                            [119.243881225585938, 28.127140045166016],
                            [119.227142333984375, 28.121957778930664],
                            [119.210296630859375, 28.117033004760742],
                            [119.193359375, 28.112363815307617],
                            [119.17633056640625, 28.107955932617188],
                            [119.159225463867188, 28.103805541992188],
                            [119.142036437988281, 28.099920272827148],
                            [119.124778747558594, 28.096296310424805],
                            [119.107452392578125, 28.092937469482422],
                            [119.090057373046875, 28.089841842651367],
                            [119.072616577148438, 28.087015151977539],
                            [119.05511474609375, 28.084451675415039],
                            [119.037567138671875, 28.082157135009766],
                            [119.019973754882813, 28.080131530761719],
                            [119.002349853515625, 28.078376770019531],
                            [118.984687805175781, 28.076887130737305],
                            [118.967002868652344, 28.07567024230957],
                            [118.949302673339844, 28.074724197387695],
                            [118.93157958984375, 28.074047088623047],
                            [118.913848876953125, 28.073640823364258],
                            [118.896110534667969, 28.073507308959961]
                        ]
                    ]
                }
            }]
        }
    }
    var lowAltPointArr = [
        "张家界/荷花机场#29°06′11″#110°26′37″",
        "岳阳/三荷机场#29°18′46″#113°16′55″",
        "常德/桃花源机场#28°55′08″#111°38′23″",
        "衡阳/南岳机场#26°43′20″#112°37′05″",
        "怀化/芷江机场#27°26′38″#109°42′19″",
        "邵阳/武冈机场#26°48′22″#110°38′28″",
        "永州/零陵机场#26°20′20″#111°36′36″",
        "郴州/北湖机场#25°45′13″#112°50′44″",
        "芦淞机场#27°46′18″#113°12′26″",
        "开慧机场#28°35′27″#113°11′08″",
        "尖山机场#28°14′23″#112°51′36″",
        "宁乡巷子口机场#28°06′55″#111°57′16″",
        "衡阳大浦机场#27°01′05″#112°45′54″",
        "云台山机场#28°21′59″#110°59′22″",
        "江华桥头铺#25°15′38″#111°32′31″",
        "大通湖#29°10′23″#112°38′45″",
        "古丈坐龙峡#28°42′24″#109°56′37″",
        "桥头河机场#27°51′16″#111°52′39″",
        "桂东八面山#26°01′57″#113°56′16″",
        "飞天山机场#25°54′17″#113°08′25″",
        "衡阳金华山#27°04′20″#112°11′29″",
        "祁东#26°45′17″#112°05′09″",
        "萍乡市#27°38′38″#113°49′17″",
        "南江镇#28°59′13″#113°43′36″",
        "富里镇#27°50′04″#113°43′05″",
        "安定镇#28°34′48″#113°43′14″",
        "慈利机场#29°27′21″#110°43′24″",
        "洪家关#29°28′16″#110°11′26″",
        "龙山#29°29′37″#109°28′52″",
        "保靖#28°40′10″#109°37′51″",
        "湘西土家族苗族自治州#28°18′27″#109°44′11″",
        "MAKLA#28°02′06″#109°41′06″",
        "龙家堡乡#27°46′50″#109°44′30″",
        "绥宁#26°31′20″#110°04′48″",
        "吉首枫香#28°23′36″#109°49′01″",
        "新宁崀山#26°28′23″#110°52′35″",
        "道县营阳#25°27′05″#111°38′37″",
        "东上乡#26°41′30″#113°53′58″",
        "睦村乡#26°36′49″#113°55′15″",
        "湘阴#28°44′45″#112°59′52″",
        "湘潭#27°42′11″#112°58′16″",
        "安化大百龙#28°26′41″#111°20′51″",
        "资阳#28°37′18″#112°19′20″",
        "湘乡泉塘#27°43′32″#112°26′42″",
        "邵阳虎形#27°33′51″#110°39′37″",
        "辰溪机场#27°58′36″#110°13′16″",
        "东安舜皇#26°19′35″#111°12′17″",
        "宁远福家坪#25°33′10″#111°55′36″",
        "新田#25°49′02″#112°10′02″",
        "桂阳仁义机场#25°46′24″#112°41′58″",
        "宜章莽山#25°05′50″#112°45′20″",
        "古商城#27°10′32″#110°01′58″",
        "常宁兰江#26°22′50″#112°21′21″",
        "南岳镇#27°12′25″#112°44′20″",
        "君山#29°21′08″#113°00′18″",
        "新邵新田铺机场#27°20′12″#111°21′41″",
        "资兴#26°06′43″#113°17′29″",
        "茶陵#26°40′25″#113°30′57″",
        "炎陵九龙#26°29′19″#113°40′06″",
        "耒阳公平#26°14′40″#112°51′50″",
        "衡山开云机场#27°16′00″#112°48′24″",
        "塘渡口#27°03′00″#111°19′12″",
        "桃江桃花江#28°28′04″#112°11′33″",
        "夯沙乡#28°24′50″#109°40′18″",
        "汝城安仁#25°36′45″#113°24′36″",
        "回龙山#26°11′48″#113°29′21″",
        "攸县紫云#27°02′37″#113°24′29″",
        "淦田#27°28′38″#113°08′40″",
        "汝城#25°32′50″#113°43′03″",
        "临武龙宫#25°18′50″#112°33′12″",
        "宜章#25°24′00″#112°54′16″",
        "临湘滨江#29°42′58″#113°27′28″",
        "江永黄甲岭#25°11′30″#111°24′46″",
        "赫山机场#28°26′03″#112°19′16″",
        "黄盖#29°37′10″#113°23′23″",
        "月田镇#29°03′14″#113°37′26″",
        "鹿角#29°07′53″#113°01′55″",
        "华容#29°31′53″#112°28′41″",
        "会同#26°49′51″#109°46′01″",
        "渠阳#26°38′39″#109°40′02″",
        "沅陵朝瓦溪#28°27′54″#110°22′02″",
        "新化#28°15′00″#110°38′00″",
        "汉寿清水湖机场#28°49′30″#111°54′37″",
        "永顺#28°53′14″#109°52′36″",
        "零阳（水）#29°40′24″#110°06′28″",
        "桑植官地坪#29°34′41″#110°26′25″",
        "石门#29°36′49″#111°26′45″",
        "桃源栖凤山#29°07′05″#111°19′42″",
        "南洲#29°18′19″#112°22′25″",
        "麻阳锦江#27°51′04″#109°50′29″",
        "新晃大龙#27°21′51″#109°07′28″",
        "中方#27°18′50″#109°53′56″",
        "通道#26°03′50″#109°48′06″",
        "城步#26°39′23″#110°32′52″",
        "祁阳#26°29′07″#111°50′02″",
        "邵阳中心#27°34′20″#111°37′23″",
        "冷水江#27°36′55″#111°26′41″",
        "湘乡毛田#27°41′02″#112°05′39″",
        "双峰#27°22′54″#112°11′51″",
        "杨桥#27°09′13″#111°57′35″",
        "岘山镇#26°56′38″#112°20′00″",
        "坪塘机场#28°01′06″#112°53′51″",
        "拱塘#26°47′28″#113°34′22″",
        "蓝山#25°28′24″#112°12′06″",
        "樟市#25°51′59″#112°43′45″",
        "正和机场#25°44′35″#112°47′46″",
        "嘉禾#25°37′26″#112°30′55″",
        "清溪#27°55′49″#112°31′26″",
        "醴陵南部#27°36′34″#113°31′25″",
        "醴陵#27°30′28″#113°28′45″",
        "九华#27°57′45″#112°53′06″",
        "平江安定机场#28°38′56″#113°39′09″",
        "浏阳永和#28°16′44″#113°50′15″",
        "古港镇#28°17′44″#113°42′49″",
        "澧县#29°47′58″#111°49′54″",
        "常德虎形#28°43′06″#111°24′16″",
        "泸溪#28°14′21″#110°11′43″",
        "溆浦北斗溪#27°43′09″#110°38′10″",
        "长胜村#26°22′05″#112°53′20″",
        "永兴#26°06′46″#113°07′46″",
        "射埠#27°37′22″#112°47′31″",
        "岳阳万石湖机场#29°10′14″#113°01′04″",
        "中洲乡#29°03′53″#113°03′52″",
        "沅江赤山岛#28°54′50″#112°16′55″",
        "麻塘#29°13′19″#113°05′35″",
        "毛家冲#26°57′32″#112°32′10″",
        "洞口#28°03′17″#110°36′25″",
        "夹山镇#29°30′56″#111°25′58″",
        "南县#29°25′02″#112°24′11″",
        "三湾乡#26°53′52″#113°57′11″",
        "姚家坝#27°46′26″#113°19′44″",
        "八宝镇#26°20′48″#112°05′18″",
        "汨罗#28°54′59″#113°04′53″",
        "岳阳毛田#29°13′57″#113°37′24″",
        "安仁#26°31′47″#113°23′36″",
        "宋家嘴镇#29°28′52″#112°28′53″",
        "闪石乡#27°17′22″#114°02′58″",
    ];

    let ExtraDataArr = [
        "去往广西柳州方向#25°28′36″#109°40′16″",
        "去往广西桂林方向#25°13′46″#110°18′49″",
        "去往贵州黔东南方向#25°39′27″#108°42′15″",
        "去往广西贺州方向#24°51′22″#111°19′48″",
        "去往广东清远方向#24°49′24″#112°31′59″",
        "去往广东韶关方向#25°02′54″#113°33′56″",
        "去往江西赣州方向#25°50′40″#114°42′56″",
        "去往江西吉安市井冈山方向#26°48′52″#114°42′56″",
        "去往江西萍乡方向#27°40′45″#114°33′23″",
        "去往江西宜春方向#28°30′48″#114°36′23″",
        "去往江西九江方向#29°00′54″#114°33′23″",
        "去往湖北咸宁方向#29°44′44″#114°11′57″",
        "去往湖北荆州方向#30°06′28″#112°24′11″",
        "去往湖北宜昌方向#30°06′28″#111°26′45″",
        "去往湖北恩施方向#30°02′13″#110°00′37″",
        "去往重庆黔江方向#29°23′37″#108°42′15″",
        "去往重庆方向#28°18′50″#108°42′15″",
        "去往贵州铜仁方向#27°35′48″#108°42′15″",
        "去往贵州凯里方向#26°40′05″#108°42′15″",
    ];

    const AirportFruit = {
        永州零陵机场: "零陵机场",
        岳阳三荷机场: "三荷机场",
        安华云台山直升机场: "云台山机场",
        平江安定机场: "安定机场",
        岳阳南湖机场: "南湖机场",
        株洲芦淞通用机场: "芦淞机场",
        铜官窑: "铜官窑机场",
        邵阳武冈机场: "武冈机场",
        怀化芷江机场: "芷江机场",
        宁乡巷子口通用机场: "巷子口机场",
        长沙县开慧通用机场: "开慧机场",
        长沙黄花机场: "黄花机场",
        衡阳衡东县大浦通用机场: "大浦机场",
        常德桃花源机场: "桃花源机场",
        郴州北湖机场: "北湖机场",
        郴州桂阳仁义通用机场: "仁义机场",
        衡阳南岳机场: "南岳机场",
        邵阳晒谷滩直升机场: "晒谷滩机场",
        长沙尖山直升机场: "尖山机场",
        张家界三官寺机场: "三官寺机场",
        张家界荷花机场: "荷花机场",
        平江安定: "安定机场",
        郴州北湖: "北湖机场",
        湘阴洋沙湖: "洋沙湖机场",
        桂阳正和直升机场: '正和机场',
    };


    const AirportFruitHeight = {
        永州零陵机场: 0,
        岳阳三荷机场: 0,
        安华云台山直升机场: 734.4,
        平江安定机场: 0,
        岳阳南湖机场: 50,
        株洲芦淞通用机场: 70,
        铜官窑: 0,
        邵阳武冈机场: 0,
        怀化芷江机场: 0,
        宁乡巷子口通用机场: 245,
        长沙县开慧通用机场: 78,
        长沙黄花机场: 332,
        衡阳衡东县大浦通用机场: 75,
        常德桃花源机场: 0,
        郴州北湖机场: 0,
        郴州桂阳仁义通用机场: 249,
        衡阳南岳机场: 0,
        邵阳晒谷滩直升机场: 200,
        长沙尖山直升机场: 77.5,
        张家界三官寺机场: 216.4,
        张家界荷花机场: 0,
        桂阳正和直升机场: 227,
    };

    let obj = {
        ToDegrees,
        ToDigital,
        getBase64,
        getDate,
        dms2ddd,
        getAngle,
        dateFormat,
        airTimeFormat,
        timeZoneFormat,
        vectorToDegrees,
        vectorToSpeed,
        getColorRamp,
        hpa2Altitude,
        urlToBlob,
        mask_top,
        lowAltPointArr,
        ExtraDataArr,
        Dms2D,
        AirportFruit,
        AirportFruitHeight
    };

    for (let i in obj) {
        window[i] = obj[i]
    }
})(window);